module.exports = __webpack_public_path__ + "assets/images/pages/ebaysocial/ebaysocial-1.webp?7fd86a91";